// extracted by mini-css-extract-plugin
module.exports = {"table":"Resume_table__28gBd","tableContainer":"Resume_tableContainer__3xBfr","blank":"Resume_blank__1jhcz","col1":"Resume_col1__33cLI","col2":"Resume_col2__2zJoD"};